import React, { useLayoutEffect, useState } from "react";
import * as API from "src/api/risk/reference";
import _ from "lodash";
import { Select } from "antd";

const DepartmentTseh = (props) => {
  const [list, setList] = useState([]);

  const { Option } = Select;

  useLayoutEffect(() => {
    API.getMatrixProb().then((res) => {
      setList(res);

      // if (res?.length > 0 && !props.value) {
      //   var department = _.find(res, {
      //     department_code: user?.info?.tseh_code,
      //   });
      //   props.onChange(department.departmentcode);
      // }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id]);

  return (
    <>
      <Select
        showSearch
        allowClear
        placeholder="Сонгоно уу."
        optionFilterProp="children"
        className="w-full"
        {...props}
      >
        {_.map(list, (item) => {
          return (
            <Option key={item.id} value={item.id}>
              {item.id} | {item.probability_name}
            </Option>
          );
        })}
      </Select>
    </>
  );
};

export default React.memo(DepartmentTseh);
